/* global $ */
/* eslint no-unused-vars: 0 */

if (
  !$('.searchandfilter')
    .find('[type="checkbox"]')
    .filter(':checked').length
) {
  $('body').addClass('sandf-readmore');
}
$('li[data-sf-field-input-type="checkbox"]').each((index, element) => {
  const $element = $(element);
  const $itemCount = $(element)
    .find('ul')
    .find('li').length;
  const $items = $itemCount - 4;
  const $message = 'See ' + $items + ' more >';
  $(element)
    .find('ul')
    .addClass('checkbox-filter-' + index++);
  if ($itemCount > 4 && $itemCount !== 4) {
    $element.append('<a class="filter-see-more">See more ></a>');
    $element.find('.filter-see-more').html($message);
    $element.find('a.filter-see-more').on('click', () => {
      $element.find('ul').addClass('see-more');
      $element.find('a.filter-see-more').hide();
      $('.filter-form').addClass('no-sticky');
      if ($element.get(0).scrollIntoView) {
        setTimeout(() => {
          $element.get(0).scrollIntoView({
            behavior: 'smooth',
            block: 'end',
            inline: 'nearest',
          });
        }, 100);
      }
    });
  }
});
